<template>
  <div class="page agricoltura">
    <GeneralHeader :header="agricoltura.generalHeader[0]" />
    <TitleText :item="agricoltura.sezioneTitoloTestoPagina[0]" />
    <TextImageWithBg
      :block="agricoltura.sezioneImmagineTesto[0]"
      type="custom3"
    />
    <TextImageWithBg
      :block="agricoltura.sezioneImmagineTesto[1]"
      type="custom3"
    />
  </div>
</template>

<script setup>
import { useStore } from '@/store/index.js'
import queries from '@/graphql/craft/queries/index.js'

const { configuration } = useStore()

// Fetch Data
const query = queries.agricoltura.getAgricoltura

const variables = computed(() => ({
  site: configuration.site,
}))

const { data } = await useGraphql(query, variables)

if (!data.value.agricolturaPageEntries?.[0]) {
  throw createError({ statusCode: 404 })
}
const agricoltura = computed(() => data.value.agricolturaPageEntries?.[0])
const seo = computed(() => data.value?.agricolturaPageEntries?.[0]?.seo || {})

// Seo
useSeo({
  ...seo.value,
  meta: [
    {
      name: 'description',
      content: seo.value?.description,
    },
  ],
})
</script>
